var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[(_vm.leftArrow)?_c('v-btn',{staticClass:"rounded-sm",attrs:{"fab":"","color":"#fff"},on:{"click":_vm.goback}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-chevron-left")])],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }